import { BmHttp as Http } from "../utils/Global"

// HM-07 Fase 2: estas funciones llamaban antes directamente a la API de
// Contífico desde el navegador (BmcHttp, con el token embebido en el bundle
// del frontend). Ahora llaman al backend propio (BmHttp, con el JWT normal
// de sesión), que es quien habla con Contífico usando CONTIFICO_TOKEN desde
// el servidor. El token de Contífico ya no llega nunca al navegador.
// Ver context/seguridad/hm07/frontend-exposure.md y frontend-remediation.md.

export const getCodeContifico = async (code) => {
    try {

        return await Http().get(`billing/contifico/producto`, { params: { codigo: code } })

    } catch (error) {
        return null
    }
}

export const getDocumentoContifico = async(id) => {
    try {

        const { data }  = await Http().get(`billing/contifico/documento/${id}`);
        return { mensaje: data.message, cod_error : 0, data: data.data, success: data.success };

    } catch (error) {
        const { response } = error;
        return { mensaje: response?.data?.message, cod_error : 1, data: "", success: false };
    }
}

export const getCuentaBancariaContifico = async() => {
    try {

        const { data }  = await Http().get(`billing/contifico/cuentas-bancarias`);
        return { mensaje: data.message, cod_error : 0, data: data.data, success: data.success };

    } catch (error) {
        const { response } = error;
        return { mensaje: response?.data?.message, cod_error : 1, data: "", success: false };
    }
}
